// table info
export const tableHeaderArr = [
  "Name",
  "Code",
  "Cost Price",
  "Min Price",
  "Price",
  "Units",
];

export const columnNames = [
  "name",
  "code",
  "cost_price",
  "min_price",
  "price_1",
  "units_1",
];

export const viewRoute = "/file-maintenance/stock-items/view";
